import React from 'react';
import { Check } from 'lucide-react';

/* Weekly consistency dots (Mon..Sun). `week` is the array returned by the
   backend: [{ label, completed, is_future, is_today }] */
const WeeklyConsistencyDots = ({ week = [] }) => (
  <div className="flex items-center gap-2 sm:gap-3" data-testid="weekly-consistency-dots">
    {week.map((d, i) => {
      let cls = 'bg-neutral-50 text-neutral-300 border border-neutral-200';
      if (d.completed) cls = 'bg-emerald-500 text-white shadow-sm ring-4 ring-emerald-50';
      else if (d.is_future) cls = 'bg-neutral-100 text-neutral-400';
      return (
        <div key={i} className="flex flex-col items-center gap-1.5">
          <div
            className={`w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all ${cls} ${
              d.is_today && !d.completed ? 'ring-2 ring-emerald-300' : ''
            }`}
            data-testid={`dot-${d.label}-${i}`}
          >
            {d.completed ? <Check size={16} strokeWidth={3} /> : ''}
          </div>
          <span className="text-[11px] font-medium text-neutral-400">{d.label}</span>
        </div>
      );
    })}
  </div>
);

export default WeeklyConsistencyDots;
